import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./index.rwd.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./store/front_end_data_base/store.js"; // Ensure you export persistor from your store

// ____________________________________________________________
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </PersistGate>
  </Provider>
);

// FUNCITON WITHOUT REDUX PERSIST *************************************

// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import App from './App';
// import { BrowserRouter } from "react-router-dom"
// import { Provider } from 'react-redux';

// import store from './store/redux/store.js';

// // ____________________________________________________________
// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <Provider store={store}>
//     <BrowserRouter>
//       <App />
//     </BrowserRouter>
//   </Provider>
// );
